<!--
 * @Author: xuxiaofei
 * @Date: 2022-11-02 14:52:31
 * @LastEditTime: 2022-11-02 17:00:15
 * @LastEditors: 许晓飞 xuxiaofei.xxffe@sunyur.com
 * @Description: 需求提报详情页
 -->
<template>
  <div>
    <div v-if="showNoData && showDataTip && !laoding" style="text-align: center">{{pageText.noData}}</div>
    <extend-field
      v-else
      ref="extendField"
      v-bind="$attrs"
      :fieldList="detailData.fields"
    />
  </div>
 
</template>

<script>
import { Buttons } from './../../../../index.js'
import { componentMessage } from './../../utils'
import Api from './api'
import GetData from './../../../../utils/response'
import ExtendField from './../../products/extend-field/detail/index.vue'
import i18n from './i18n.js'
const pageText = window.fe.getPageText(i18n)
const defaultDetailData = {fields: []}
export default {
  name: 'DemandSubmissionDetail',
  components: {
    Buttons,
    ExtendField
  },
  props: {
    // 需求提报的id
    demandId: {
      type: [Number, String],
      required: true
    },
    // 是否展示数据相关的提示
    showDataTip: {
      type: Boolean,
      default: false
    }
	},
  data () {
    return {
      // 详情数据
      detailData: JSON.parse(JSON.stringify(defaultDetailData)),
      project: window.fe.project,
      pageText,
      laoding: false
    }
  },
  computed: {
    showNoData () {
      let status = true
      Array.isArray(this.detailData.fields) && this.detailData.fields.forEach(i => {
        !(this.project === 'supplier' && i?.supplierDisplay === 0) && (status = false)
      })
      return status
    }
  },
  watch: {
    // 是否根据需求提报id获取详情
    demandId: {
      handler: function (newVal) {
        this.getBizDataDetails()
      },
      immediate: true
    }
  },
  async created () {
    let verifyResult = componentMessage(['purchaser', 'supplier', 'mall'], '需求提报详情组件')
		if (verifyResult) return
  },
  methods: {
   // 获取详情
		async getBizDataDetails () {
      this.detailData = JSON.parse(JSON.stringify(defaultDetailData))
      if ((this.demandId || this.demandId === 0) && !this.laoding) {
        this.laoding = true
        const api = Api.getBizDataDetails
        const data = await GetData(this.$http(api.type, api.url, { sysBizDataCode: this.demandId }))
        this.laoding = false
        if (data.isOk && data.content) {
          this.detailData = data.content
        }
      }
      
		}
  }
}
</script>

<style lang="scss" scoped>

</style>
